var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { equals, head, merge, omit, gt } from "ramda";
import { Money } from "@upserve/financials";
import { LOG_OUT } from "actions/authentication";
import { VALIDATE_CC_FIELD_ON_BLUR } from "actions/credit_cards";
import { RETURN_CHECKOUT_FORM_ERRORS, CLEAR_CHECKOUT_FORM_ERRORS, } from "actions/online_ordering";
import { RECEIVE_CALCULATED_TOTALS, APPLY_PROMO, AWAIT_CALCULATED_TOTALS, } from "actions/online_ordering/calculate_totals";
import { PROCEED_TO_CHECKOUT, SELECT_CARD_FROM_DROPDOWN, SET_PAYMENT_GIFT_CARD_INFO, SET_PAYMENT_GIFT_CARD_REQUEST, UPDATE_NEW_CREDIT_CARD, UPDATE_PAYMENT_TYPE, UPDATE_SELECTED_TIP_OPTION, UPDATE_TIP, } from "actions/online_ordering/checkout";
import { UPDATE_CONSUMER_INFO } from "actions/online_ordering/consumer";
import { RequestStatus } from "types/requests";
var initialCalculatedTotals = {
    total: 0,
    tax: 0,
    deliveryFee: 0,
    menuTotal: 0,
    orderTotal: 0,
    upserveFee: 0,
    promo: {
        discount: 0,
        percentage: 0,
    },
    balanceDue: 0,
    payments: {
        payments: [],
    },
    fees: {
        consumerFee: 0,
        deliveryFee: 0,
        serviceFee: 0,
        total: 0,
        version: "",
    },
    serviceFee: 0,
};
// -1 is never a reasonable value for total, so use it here to signal waiting for response from the calculation endpoint
// filed HQ-8839 to handle this better
var awaitingCalculatedTotals = __assign(__assign({}, initialCalculatedTotals), { total: -1 });
var initialState = {
    calculatedTotals: initialCalculatedTotals,
    errors: null,
    isAddingNewCard: true,
    paymentType: "credit",
    promoCode: "",
    promoCodeIsValid: null,
    selectedCard: null,
    newCreditCard: {
        address1: "",
        address2: "",
        cardNumber: "",
        city: "",
        cvv: "",
        errors: null,
        expiryMonth: "",
        expiryYear: "",
        firstName: "",
        lastName: "",
        state: "",
        zip: "",
    },
    giftCards: [],
    giftCardsRequest: RequestStatus.NOT_STARTED,
    tip: Money(0),
    selectedTipOption: undefined,
};
function payment(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case UPDATE_CONSUMER_INFO: {
            if (gt(action.consumerInfo.cards.length, 0)) {
                return __assign(__assign({}, state), { selectedCard: action.consumerInfo.cards[0].dropdownFormat, isAddingNewCard: false });
            }
            return __assign(__assign({}, state), { selectedCard: "+ Add a new card", isAddingNewCard: true });
        }
        case UPDATE_PAYMENT_TYPE: {
            if (equals(action.paymentType, "credit") &&
                equals(action.cards.length, 0)) {
                return __assign(__assign({}, state), { paymentType: action.paymentType, selectedCard: "+ Add a new card", isAddingNewCard: true });
            }
            if (equals(action.paymentType, "credit")) {
                return __assign(__assign({}, state), { paymentType: action.paymentType, selectedCard: action.cards[0].dropdownFormat, isAddingNewCard: false });
            }
            return __assign(__assign({}, state), { paymentType: action.paymentType });
        }
        case SELECT_CARD_FROM_DROPDOWN: {
            if (equals(action.cardOption, "+ Add a new card")) {
                return __assign(__assign({}, state), { selectedCard: action.cardOption, isAddingNewCard: true });
            }
            return __assign(__assign({}, state), { selectedCard: action.cardOption, isAddingNewCard: false });
        }
        case UPDATE_NEW_CREDIT_CARD:
            return __assign(__assign({}, state), { newCreditCard: __assign(__assign({}, state.newCreditCard), action.newCreditCard) });
        case VALIDATE_CC_FIELD_ON_BLUR: {
            if (action.error) {
                return __assign(__assign({}, state), { newCreditCard: __assign(__assign({}, state.newCreditCard), { errors: merge(state.newCreditCard.errors || {}, action.error) }) });
            }
            return __assign(__assign({}, state), { newCreditCard: __assign(__assign({}, state.newCreditCard), { errors: omit([action.field], state.newCreditCard.errors) }) });
        }
        case APPLY_PROMO: {
            var _a = action, promoCode = _a.promoCode, isValidated = _a.isValidated;
            return __assign(__assign({}, state), { promoCode: promoCode, promoCodeIsValid: isValidated });
        }
        case AWAIT_CALCULATED_TOTALS: {
            return __assign(__assign({}, state), { calculatedTotals: awaitingCalculatedTotals });
        }
        case RECEIVE_CALCULATED_TOTALS: {
            return __assign(__assign({}, state), { calculatedTotals: action.calculatedTotals });
        }
        case RETURN_CHECKOUT_FORM_ERRORS: {
            return __assign(__assign({}, state), { newCreditCard: __assign(__assign({}, state.newCreditCard), { errors: action.ccFormErrors }) });
        }
        case CLEAR_CHECKOUT_FORM_ERRORS: {
            return __assign(__assign({}, state), { newCreditCard: __assign(__assign({}, state.newCreditCard), { errors: null }), errors: null });
        }
        case PROCEED_TO_CHECKOUT: {
            if (equals(action.paymentOptions.length, 1)) {
                return __assign(__assign({}, state), { paymentType: head(action.paymentOptions) });
            }
            return state;
        }
        case LOG_OUT: {
            return initialState;
        }
        case SET_PAYMENT_GIFT_CARD_REQUEST: {
            return __assign(__assign({}, state), { giftCardsRequest: action.status });
        }
        case SET_PAYMENT_GIFT_CARD_INFO: {
            return __assign(__assign({}, state), { giftCards: action.giftCards });
        }
        case UPDATE_TIP: {
            return __assign(__assign({}, state), { tip: action.tip });
        }
        case UPDATE_SELECTED_TIP_OPTION: {
            return __assign(__assign({}, state), { selectedTipOption: action.selectedTipOption });
        }
        default:
            return state;
    }
}
export default payment;
